
import React, { Component } from 'react';
import { withAsyncActions } from 'react-async-client';
import { Field } from 'formik';
import yup from 'yup';
import { Alert, Button, Row } from 'antd';

import { postPasswordReset } from 'actions/asyncActions';
import withAutoFocusForm from 'components/hocs/withAutoFocusForm';
import withForm from 'components/hocs/withForm';
import Input from 'components/common/form/Input';

const validationSchema = yup.object({
    email: yup.string().required(),
});

@withAutoFocusForm
@withAsyncActions({
    formAction: postPasswordReset
}, { resetOnMount: true })
@withForm({
    validationSchema: validationSchema,
})
export default class PasswordRecovery extends Component {
    render() {
        const { meta } = this.props.formAction;

        return meta.success ? (
            <Alert message="Ссылка на восстановление пароля отправлена на указанный вами e-mail" type="success" />
        ) : (
            <div className="promo-form">
                <Field
                    name='email'
                    component={Input}
                    placeholder='E-mail'
                />
                <Row className="form-row m-b-20">
                    <Button
                        type='primary'
                        size='large'
                        htmlType='submit'
                    >
                        Отправить
                    </Button>
                </Row>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/landing/PasswordRecovery.js